import React, { Component } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'

import { envConstants } from '../../constants'
import { holeHelper } from '../../helpers'
import { saveInterventions } from '../../actions'

class HoleLine extends Component {
  constructor(props) {
    super(props)
    this.state = {
      interventions: this.props.d.interventions,
      estimedInterventions: this.props.d.estimedInterventions
    }
  }

  changeInterventions(e) {
    const payload = {
      id: this.props.d.id,
      interventions: parseInt(e.target.value)
    }
    this.setState({ interventions: e.target.value }, () => {
      this.props.saveInterventions(payload)
    })
  }

  changeEstimedInterventions(e) {
    const payload = {
      id: this.props.d.id,
      estimedInterventions: parseInt(e.target.value)
    }
    this.setState({ estimedInterventions: e.target.value }, () => {
      this.props.saveInterventions(payload)
    })
  }

  render() {
    const d = this.props.d
    const s = this.state

    const dropdownOptions = Array.from(Array(11).keys()).map((x) => {
      return (
        <option key={x} value={x}>
          {x === 0 ? '-' : x}
        </option>
      )
    })
    let estimedInterventions = d.estimedInterventions
    if (this.props.imInRestores) {
      estimedInterventions = (
        <select
          value={s.estimedInterventions}
          disabled={d.status === 0 || !this.props.imInRestores}
          onChange={(e) => this.changeEstimedInterventions(e)}
        >
          {dropdownOptions}
        </select>
      )
    }

    let interventions = d.interventions
    if (this.props.imInRestores) {
      interventions = (
        <select
          value={s.interventions}
          disabled={d.status < 2}
          onChange={(e) => this.changeInterventions(e)}
        >
          {dropdownOptions}
        </select>
      )
    }

    return (
      <tr>
        <td className={'status ' + holeHelper.colorStatus(d.status)}>
          <img src={holeHelper.holeStatusMarker(d)} alt={d.status} />
        </td>
        <td>{d.id}</td>
        <td>{d.formattedAddress}</td>
        <td>
          {moment.unix(d.lastDetection).format(envConstants.momentFormat)}
        </td>
        <td>{d.anomalyType}</td>
        <td>{estimedInterventions}</td>
        <td>{interventions}</td>
        <td>
          <img src={holeHelper.holeMarker(d)} alt={d.severity} />
        </td>
      </tr>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, { saveInterventions })(HoleLine)
